import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../common/EnhancedTableHead';

interface Props {
  items: any[];
  numSelected: number;
  enableSelection: boolean;
  onRowSelectionToggled: (row: any) => void;
  onSelectAllToggled: (checked: boolean) => void;
}

interface ActionTableRowProps {
  row: any;
  enableSelection: boolean;
  onRowSelectionToggled: (row: any) => void;
}

const headRows: HeadRow[] = [
  { id: 'actionGroup', disablePadding: false, label: 'Action Group' },
  { id: 'actionName', disablePadding: false, label: 'Action Name' },
  { id: 'testName', disablePadding: false, label: 'Test Name' },
  { id: 'testVersion', disablePadding: false, label: 'Test Version' }
];

const ActionTableRow = React.memo((props: ActionTableRowProps) => {
  const { row, enableSelection, onRowSelectionToggled } = props;
  return (
    <TableRow key={row.actionName}>
      {enableSelection && <TableCell padding="checkbox">
        <Checkbox
          color="primary"
          checked={row.selected}
          onChange={() => onRowSelectionToggled(row)}
        />
      </TableCell>}
      <TableCell>{row.actionGroup}</TableCell>
      <TableCell>{row.actionName}</TableCell>
      <TableCell>{row.testName}</TableCell>
      <TableCell>{row.testVersion}</TableCell>
    </TableRow>
  );
});

function CreateExecutionTestActionsTable(props: Props) {
  const {
    numSelected,
    onRowSelectionToggled,
    enableSelection,
    onSelectAllToggled
  } = props;
  const [order, setOrder] = React.useState<Order>('asc');
  const [orderBy, setOrderBy] = React.useState<string>('actionName');

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const sortedRows = sortRows(props.items, getSorting(order, orderBy));

  return (
    <TableContainer>
      <Table>
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          fields={headRows}
          onRequestSort={handleRequestSort}
          selectAllOptions={enableSelection ? {
            numSelected: numSelected,
            rowCount: sortedRows.length,
            onChange: onSelectAllToggled
          } : null}
        />
        <TableBody>
          {sortedRows.map(row => (
            <ActionTableRow
              key={row.actionName}
              row={row}
              enableSelection={enableSelection}
              onRowSelectionToggled={onRowSelectionToggled}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CreateExecutionTestActionsTable;
